export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2025 (CLASS - 10).7c79b811.pdf";